module.exports = __webpack_public_path__ + "static/littleWomen0-1abff6bdf70b8c9e1bf30d90ef5c1402.jpg";